export default {
  roleFeature: 'mrx-gateway/mrxassistmemberservice/admin/api/rolefeature',
  getRoles: 'mrx-gateway/mrxassistmemberservice/admin/api/roles'
}
